import { FC } from 'react';

import { Icon } from './Icon';
import { SvgIcon } from './SvgIcon.type';

export const IconArrowUp: FC<SvgIcon> = (props) => (
  <Icon {...props} viewBox="0 0 24 24" name="arrow-up">
    <path d="M12.424 4.576 18.848 11l-.848.848-5.4-5.4V19.6h-1.2V6.448l-5.4 5.4L5.15 11l6.425-6.424a.6.6 0 0 1 .848 0Z" />
  </Icon>
);
